import { IncomingMessage } from "http";
import { buildExpressRequestPagesRouter } from "./express-request";
import { getStorePresentationInstance } from "./store-presentation-provider";

export type EnrichedCountry = Awaited<
  ReturnType<ReturnType<typeof getStorePresentationInstance>["getCountry"]>
> & {
  siteBasePath: string;
};

export const getCountry = async (req: IncomingMessage) => {
  const store = getStorePresentationInstance();
  const { request } = await buildExpressRequestPagesRouter(req);

  const countryData = await store.getCountry({
    request,
    response: {},
  });

  const siteBasePath =
    countryData.url.split(".com")[1]?.replace(/\/$/, "") || "/";

  return {
    ...countryData,
    siteBasePath,
  };
};
